"use client";
import React from "react";
import type { ShopPageProps } from "../../types";
import { SharedElementsLoader } from "../page-template-loaders/shared-elements-loader";
import FilterAndSort from "../elements/FilterAndSort";

const ShopPage: React.FC<ShopPageProps> = ({
  products,
  itemPerPage,
  productsTotalCount,
  offset,
  loading,
}) => {
  return (
    <SharedElementsLoader>
      <FilterAndSort
        products={products}
        itemPerPage={itemPerPage}
        productsTotalCount={productsTotalCount}
        offset={offset}
        loading={loading}
      />
    </SharedElementsLoader>
  );
};

export default ShopPage;
